import React from "react";
import "../Home.css";
import abtimg1 from "../../../assets/abtimg1.png";
import abtimg2 from "../../../assets/abtimg2.png";

export default function About() {
  return (
    <div className="about-container" id="about">
      <div className="intro-section">
        <div className="intro-image">
          <img src={abtimg1} alt="abtimg" width="100%" height="293px" />
        </div>
        <div className="introduction">
          <h1 className="intro-title">About</h1>
          <p className="intro-content">
            STEELRYX Steel works LLC one of the leading fabrication and
            engineering solution companies in the UAE. Our company's strength is
            that we can provide a full range of services, including design,
            fabrication, supply, and installation
          </p>
        </div>
      </div>
      <div className="conclusion">
        <div className="conclude-section">
          <p className="conclude-content">
            STEELRYX is focused on delivering innovative and high quality
            engineering services and solutions using its team of qualified and
            experienced engineers. With the help of right sourcing strategy and
            a fundamental understanding of market needs and global industry
            standards, we offer high quality service at the right prices to our
            customers.
          </p>
          <button className="about-button">Check it out</button>
        </div>
        <div className="conclusion-image">
          <img src={abtimg2} alt="abtimg" width="100%" />
        </div>
      </div>
    </div>
  );
}
